import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  min-height: 100vh;
  height: 100%;
  max-width: 1280px;
  min-width: 1280px;
  margin: auto;
`;

export const Content = styled.main`
  flex: 0 0 auto;
  padding: 70px 0 0 0;
`;
